import {
  REQUEST_USER,
  CONFIRM_USER,
} from './constants'

import createReducer from '../createReducer'

export const initialState = {
}

export default createReducer(initialState, {
  [REQUEST_USER]: (state) => {
    return { ...state }
  },
  [CONFIRM_USER]: (state) => {
    return { ...state }
  },
})
